import { BrowserRouter } from 'react-router-dom';
import App from './App';

/**
 * Wrapper component that adds React Router to the app
 * For now, this just wraps the app with BrowserRouter to enable routing features
 * The actual view <-> URL syncing will happen incrementally as we migrate views
 */
export default function AppWithRouter() {
  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <App />
    </BrowserRouter>
  );
}
